// German UI copy introduced by the Oct 2026 overhaul (statistics area), translated by the DOM localizer.
export const pairs: Array<[string, string]> = [
  ["Besuche, erkannte Firmen und Seiteninteresse im gewählten Zeitraum.", "Visits, recognized companies and page interest in the selected period."],
  ["Export mit aktuellem Zeitraum erstellt.", "Export created for the current period."],
  ["Kennzahlen", "Key figures"],
  ["Besuche", "Visits"],
  ["Kein Vergleichszeitraum", "No comparison period"],
  ["Erkannte Firmen", "Recognized companies"],
  ["Anteil erkannter Besuche:", "Share of recognized visits:"],
  ["Neue Firmen", "New companies"],
  ["wiederkehrende Firmen", "returning companies"],
  ["Besuche pro Tag", "Visits per day"],
  ["Besuche pro Tag im gewählten Zeitraum", "Visits per day in the selected period"],
  ["Zeitraum wird geladen", "Loading period"],
  ["Erkannte Besuche", "Recognized visits"],
  ["Noch keine Besuche im gewählten Zeitraum.", "No visits in the selected period yet."],
  ["Nach Anzahl der Besuche", "By number of visits"],
  ["Noch keine Firmenaktivität im Zeitraum.", "No company activity in this period yet."],
  ["Nur Seitenaufrufe von Besuchern mit Einwilligung", "Only page views from visitors who gave consent"],
  ["Seite", "Page"],
  ["Ø Verweildauer", "Avg. time on page"],
  ["Conversions, an denen die Seite beteiligt war", "Conversions this page contributed to"],
  ["URL-Varianten zusammengefasst", "URL variants merged"],
  ["Heatmaps entstehen nur aus Besuchen mit Einwilligung und maskierten Aufzeichnungen.", "Heatmaps are built only from consented visits and masked recordings."],
  ["Im gewählten Zeitraum gibt es noch keine Seitenaufrufe mit Einwilligung.", "There are no consented page views in the selected period yet."],
  ["Top-Themen", "Top topics"],
  ["Besuche nach Themenbereich", "Visits by topic"],
  ["Noch keine Besuche mit Themenzuordnung im Zeitraum.", "No visits with a topic in this period yet."],
  ["Besuche erkannter Firmen nach Land", "Visits from recognized companies by country"],
  ["Noch keine Länderangaben zu erkannten Firmen.", "No country data for recognized companies yet."],
  ["Consent-Statistik", "Consent statistics"],
  ["Einwilligungsstatus im Zeitraum", "Consent status in this period"],
  ["Noch keine Consent-Daten im Zeitraum.", "No consent data in this period yet."],
  ["Nur Besucher mit Einwilligung", "Only visitors who gave consent"],
  ["Noch keine Besuche mit mehreren Seiten im gewählten Zeitraum.", "No visits with multiple pages in the selected period yet."],
  ["Besucher mit Einwilligung", "Visitors with consent"],
  ["Neu oder wiederkehrend", "New or returning"],
  ["Noch keine Besucher mit Einwilligung.", "No visitors with consent yet."],
  ["Noch keine Kanaldaten im Zeitraum.", "No channel data in this period yet."],
  ["Noch keine Gerätedaten im Zeitraum.", "No device data in this period yet."]
];
